import { Component, OnInit } from '@angular/core';
import { ListaService } from '../../_services/lista.service';
import { TipoCausalCausalSolicitudService } from '../../_services/tipo-causal-causal-solicitud.service';
import { NavService } from '../../_services/_nav.service';
import { ListaItem } from '../../_models/lista-item';
import { TipoCausalCausalSolicitud } from '../../_models/tipo-causal-causal-solicitud';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';

@Component( {
  selector: 'app-tipo-causal-editar',
  templateUrl: 'tipo-causal-editar.component.html'
} )

export class TipoCausalEditarComponent implements OnInit {

  tipCausal: ListaItem;
  lisTiposCausales: TipoCausalCausalSolicitud[] = [];
  lisCausales: ListaItem[] = [];
  guardando = false;
  carInformacionInicial = true;
  iteDisponible: TipoCausalCausalSolicitud[] = [];
  iteSeleccionado: TipoCausalCausalSolicitud[] = [];
  iteTipoCausal: TipoCausalCausalSolicitud[] = [];

  constructor( private lisServicio: ListaService,
               private tipCausalesServicio: TipoCausalCausalSolicitudService,
               private route: ActivatedRoute, private location: Location,
               private navServicio: NavService ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      forkJoin( this.lisServicio.getMasterDetailsByIdItem( 'ListasTiposCausalesSolicitudes', params[ 'id' ] ),
        this.tipCausalesServicio.listado(),
        this.lisServicio.getMasterDetails( 'ListasCausalesSolicitudes' ) ).subscribe( ( [ tipCausal, lisTipoCausalesSolicitudes, lisCausales ] ) => {
        this.tipCausal = tipCausal;
        this.lisTiposCausales = lisTipoCausalesSolicitudes;
        this.lisCausales = lisCausales;
        this.cargarItems();
        this.carInformacionInicial = false;
      } );
    } );
  }

  cargarItems() {
    this.lisCausales.map( ( s: ListaItem ) => {
      const existe = this.lisTiposCausales.find( x => x.idListaCausalSolicitud == s.idLista && x.idListaTipoCausalSolicitud == this.tipCausal.idLista );
      const exiOtro = this.lisTiposCausales.find( x => x.idListaCausalSolicitud == s.idLista && x.idListaTipoCausalSolicitud != this.tipCausal.idLista && x.indicadorHabilitado );
      if ( !exiOtro && existe && existe.indicadorHabilitado ) {
        this.iteSeleccionado.push( existe );
        this.iteTipoCausal.push( existe );
      } else if ( !exiOtro && existe ) {
        this.iteDisponible.push( existe );
        this.iteTipoCausal.push( existe );
      } else if ( !exiOtro ) {
        const nueRegistro = {} as TipoCausalCausalSolicitud;
        nueRegistro.idListaCausalSolicitud = s.idLista;
        nueRegistro.nombreListaCausalSolicitud = s.nombre;
        nueRegistro.idListaTipoCausalSolicitud = this.tipCausal.idLista;
        nueRegistro.nombreListaTipoCausalSolicitud = this.tipCausal.nombre;
        nueRegistro.indicadorHabilitado = true;
        this.iteDisponible.push( nueRegistro );
      }
    } );
    if ( this.iteDisponible.length <= 0 ) {
      this.navServicio.setMesage( 0,
        {
          severity: 'info',
          summary: 'Información',
          detail: 'No existen causales para seleccionar'
        } );
    }
  }

  guardar( items: TipoCausalCausalSolicitud[], seleccionado: boolean ) {
    this.guardando = true;
    const registros = [];
    items.map( ( s: TipoCausalCausalSolicitud ) => {
      let a = this.iteTipoCausal.find( x => x.idTipoCausalCausalSolicitud === s.idTipoCausalCausalSolicitud && x.idTipoCausalCausalSolicitud !== undefined );
      if ( a && !a.indicadorHabilitado && seleccionado ) {
        a.indicadorHabilitado = true;
        s.indicadorHabilitado = true;
        registros.push( s );
      } else if ( a && a.indicadorHabilitado && !seleccionado ) {
        a.indicadorHabilitado = false;
        s.indicadorHabilitado = false;
        registros.push( s );
      } else if ( seleccionado && !a ) {
        registros.push( s );
        this.iteTipoCausal.push( s );
      }
      a = null;
    } );

    if ( registros.length > 0 ) {
      this.tipCausalesServicio.bulk( registros ).subscribe( regActualizado => {
        regActualizado.map( ( s: TipoCausalCausalSolicitud ) => {
          const l = this.iteTipoCausal.findIndex( x => x.idListaCausalSolicitud == s.idListaCausalSolicitud );
          if ( l >= 0 && !this.iteTipoCausal[ l ].idTipoCausalCausalSolicitud ) {
            this.iteTipoCausal[ l ].idTipoCausalCausalSolicitud = s.idTipoCausalCausalSolicitud;
          }
        } );
        this.navServicio.setMesage( 2 );
        this.guardando = false;
      }, error => {
        this.navServicio.setMesage( 3 );
        this.location.back();
      } );
    } else {
      this.guardando = false;
    }
  }


  regresar() {
    this.location.back();
  }

}
